module.exports = __webpack_public_path__ + "img/16897144000122.16a21d9d.png";